export function encodeDnsQuery(hostname: string, type = 1): Uint8Array {
  const labels = hostname.replace(/\.$/, "").split(".");
  const length = 12 + labels.reduce((total, label) => total + 1 + label.length, 0) + 1 + 4;
  const bytes = new Uint8Array(length);
  const view = new DataView(bytes.buffer);

  view.setUint16(0, crypto.getRandomValues(new Uint16Array(1))[0]);
  view.setUint16(2, 0x0100);
  view.setUint16(4, 1);

  let offset = 12;
  for (const label of labels) {
    bytes[offset] = label.length;
    offset += 1;
    for (let index = 0; index < label.length; index += 1) {
      bytes[offset + index] = label.charCodeAt(index);
    }
    offset += label.length;
  }
  bytes[offset] = 0;
  offset += 1;
  view.setUint16(offset, type);
  view.setUint16(offset + 2, 1);

  return bytes;
}
